/**
 * 登入頁的品牌文案（單一來源）。
 *
 * 只有一個名字：「聯盟營運後臺」，跟登入後 header 一樣。
 * Brad 2026-09-18：登入頁不提平台（TiNY Poker / OceanAtlas）、不提這系統在做什麼
 * （營收、真人、Bot、報表…），越隱密越好。要改名只改這裡。
 */
export const BRAND = {
  name: '聯盟營運後臺',
};
